import clsx from "clsx";
import { useShallow } from "zustand/shallow";
import { AccountUser } from "@/components/account";
import { BannerBitmedia } from "@/components/ads/asd-bottom";
import { Balance } from "@/components/balance";
import { Chest } from "@/components/chest-number";
import { CountdownFreeChest } from "@/components/countdown";
import { Notification } from "@/components/notification";
import { ButtonOpenChest } from "@/components/open-chest/btn-open-chest";
import { BannerSlider } from "@/components/slider/slider";
import { useShowAds } from "@/hooks/useAds";
import { useAutoSignIn } from "@/hooks/useSignIn";
import { useAdsStore } from "@/stores/ads-store";

export default function Homepage() {
  useAutoSignIn();

  const showBanner = useShowAds();

  const [showBannerLocal] = useAdsStore(
    useShallow((state) => [state.showAds.bannerBoottom])
  );

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <AccountUser />
      <BannerSlider />
      <div className="flex-1 relative"></div>
      <div className="relative">
        <CountdownFreeChest />
        <Notification />
      </div>
      <div className="flex flex-col">
        <Balance />
        <div
          className={clsx("flex flex-col px-4 bg-[#0C0703] pt-4", {
            "pb-6": !showBanner || !showBannerLocal,
          })}
        >
          <Chest />

          <ButtonOpenChest />
        </div>

        {showBanner && showBannerLocal ? <BannerBitmedia /> : null}
      </div>
    </div>
  );
}
